<div class="row contact-container" id="contact">
  <div class="d-block d-md-none">
    <h1>{{ "Let’s Get In Touch, How Can We Help?" | translate }}</h1>
    <p>
      {{ "Have questions about pricing" | translate }}
    </p>
  </div>
  <div class="col-12 col-md-6 col-lg-7 left-container order-md-1 order-2">
    <div class="d-none d-md-block">
      <h1>{{ "Let’s Get In Touch, How Can We Help?" | translate }}</h1>
      <p>
        {{ "Have questions about pricing" | translate }}
      </p>
    </div>

    <img
      width="100%"
      class="d-none d-md-block contact-img"
      src="../../../assets/img/contact.png"
    />
    <p class="mt-4">
      {{ "Have questions about pricing" | translate }}
    </p>
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <i class="bi bi-geo-alt">
          <div class="mx-2 d-inline">{{ "Upcareer_Address" | translate }}</div>
        </i>

        <br />

        <i class="bi bi-telephone"
          ><div dir="ltr" class="mx-2 d-inline">+201555842727</div>
        </i>
      </div>
      <div class="d-flex gap-2 gap-sm-4 social">
        <a href="https://www.linkedin.com/company/up-career/" target="_blank">
          <img src="../../../assets/icon/linkedin.svg" alt="LinkedIn" />
        </a>
        <a
          href="https://www.facebook.com/@upcareer.CV/?mibextid=ZbWKwL"
          target="_blank"
        >
          <img src="../../../assets/icon/facebook.svg" alt="Facebook" />
        </a>
        <a href="https://x.com/upcareer2022?s=09" target="_blank">
          <img src="../../../assets/icon/twitter.svg" alt="Twitter" />
        </a>
      </div>
    </div>
  </div>

  <div class="col-12 col-md-6 col-lg-5 p-0 order-md-2 order-1">
    <div class="form-container">
      <h2 class="mb-4">{{ "Contact" | translate }}</h2>

      <label>{{ "Full Name" | translate }}</label>
      <div class="input-container mt-1">
        <i class="bi bi-person fs-3 left-icon"></i>
        <input type="text" placeholder="{{ 'Enter your name' | translate }}" />
      </div>
      <div class="mt-3">
        <label>{{ "Phone Number" | translate }}</label>
        <div class="input-container mt-1">
          <i class="bi bi-telephone fs-4 left-icon"></i>
          <input
            type="text"
            placeholder="{{ 'Enter your phone number' | translate }}"
          />
        </div>
      </div>
      <div class="mt-3">
        <label>{{ "Email" | translate }}</label>
        <div class="input-container mt-1">
          <i class="bi bi-envelope fs-4 left-icon"></i>
          <input
            type="text"
            placeholder="{{ 'Enter your email' | translate }}"
          />
        </div>
      </div>

      <div class="mt-3">
        <label
          >{{ "Company Name" | translate }} {{ "optional" | translate }}</label
        >
        <div class="input-container mt-1">
          <i class="bi bi-buildings fs-4 left-icon"></i>
          <input
            type="text"
            placeholder="{{ 'Enter your company name' | translate }}"
          />
        </div>
      </div>

      <div class="mt-3">
        <label>{{ "Message" | translate }} </label>
        <div class="input-container mt-1">
          <i class="bi bi-chat-left-text fs-4 left-icon area-icon"></i>

          <textarea
            type="text"
            placeholder="{{ 'Enter your message' | translate }}"
          ></textarea>
        </div>
      </div>

      <button class="w-100 gradient-button py-2">
        {{ "Send" | translate }}
      </button>
      <div class="or-divider my-4">
        <div class="line"></div>
        <label>{{ "Or" | translate }}</label>
        <div class="line"></div>
      </div>
      <a href="https://wa.me/+201555842727" target="_blank">
        <button class="contact-btn py-1">
          <img src="../../../assets/img/whatsapp-logo.png" />
          {{ "Contact with us by Whatsapp" | translate }}
        </button>
      </a>
    </div>
  </div>
</div>
